export default __webpack_public_path__ + "static/media/new.d8cff9a9.svg";